import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companyAnalysis: {
        ...store.getState().i18n.translations.en.companyAnalysis,
        peerAnalysis: {
          PEER_ANALYSIS: 'Peer analysis',
          CONTACT_US: 'Contact us',
          CANCEL: 'Cancel',
          CONFIRMATION: 'Confirmation',
          CLOSE: 'Close',
          APPLY: 'Apply',
          DESCRIPTION_CONTENT_1:
            'Our Peer Analysis feature enables users to make clear comparisons between this company and its competitors. This allows you to identify trends and anomalies in behavior and outcomes, which strengthen your evaluation and help you identify opportunities',
          DESCRIPTION_CONTENT_2:
            'A peer group can be created or generated automatically from businesses that share certain characteristics. In particular, Premium FiinGate users can create their own peer lists by selecting peers from their portfolios or searching for them in the FiinGate database. You are also receiving additional recommendations of companies that have similarities in:',
          INDUSTRY: 'Industry ',
          REVENUE: 'Revenue',
          TOTAL_ASSETS: 'Total Assets',
          YEAR_OF_OPERATION: 'Years in Operation',
          UPGRADE_NOW: 'Upgrade now',
          RECOMMENDATION_LIST: 'Recommendation list',
          SAVE_LIST: 'Save this list',
          SEARCH_PLACEHOLDER: 'Insert Company Name, Taxcode or Ticker',
          OWNERSHIP_AND_GROUP: 'Ownership & Group',
          STRUCTURE_TYPE: 'Structure of Ownership Type',
          COMPANY_NAME: 'Company Name',
          NUMBER_OF_BRANCHES: 'Number of Branches',
          NUMBER_OF_SUBSIDIARIES: 'Number of Subsidiaries',
          NUMBER_OF_ASSOCIATED_COMPANIES: 'Number of Associated Companies',
          INDIVIDUAL: 'Individual',
          STATE_OWNED_ENTERPRISES: 'State-Owned Enterprises',
          NON_STATE_ENTERPRISES: 'Non-State Enterprises',
          MULTINATIONAL_COMPANIES: 'Multinational Companies',
          OTHER: 'Others',
          FINANCIAL_STATEMENT: 'Financial Statements',
          FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_1:
            'Different sets of financial accounts result from companies that use different circulars to present their financial statements.',
          FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_2:
            "The accounts on this list come from the main company's financial statement (the first on the list), not its peer. When a peer does not have that account in their financial statements, the value is null.",
          FINANCIAL_ANALYSIS: 'Financial Analysis',
          FINANCIAL_ANALYSIS_TOOLTIP_DISCLAIMER:
            'Financial indicators is presented based on the type of the main company (the first one in the list)',
          BALANCE_SHEET: 'Balance Sheet',
          INCOME_STATEMENT: 'Income Statement',
          CASH_FLOW_STATEMENT: 'Cash Flow Statement',
          PORTFOLIO: 'Portfolio',
          CHOOSE_PORTFOLIO: 'Portfolio:',
          YEARS_OF_OPERATION: 'Years in Operation',
          CREDIT_RISK_SCORE: 'Corporate Risk Score',
          PERFORMANCE_SCORE: 'Performance Score',
          SELECTED_COMPANY: 'Selected Companies (%{numberSelect})',
          ADD_TO_PEER_LIST: 'Add to Peer List',
          INDUSTRY_TABLE: 'Industry ',
          SCORE: 'Score',
          CANCEL_SAVE_LIST_POPUP_TEXT:
            'Selected companies will not be added to peer and this list will be deleted. Do you want to continue?',
          OVER_SELECTION_POPUP_TEXT: 'You can only add up to 30 companies',
          OVER_SELECTION_CHART_POPUP_TEXT: 'You can only add up to 4 companies',
          NO_SELECTION_POPUP_TEXT: 'There is no company to save',
          SAVE_LIST_TITLE: 'Save this list',
          REMOVE_ALL: 'Remove from all',
          ADD_ALL: 'Add to all',
          ADD: 'Add',
          REMOVE: 'Remove',
          SEARCH_PORTFOLIO_PLACEHOLDER: 'Search portfolio name',
          CREATE_NEW_PORTFOLIO: 'Create new portfolio',
          ENTER_NAME_PORTFOLIO: 'Enter portfolio name',
          CREATE_PORTFOLIO: 'Create portfolio',
          TEXT_CREATE_PORTFOLIO:
            'Are you sure you want to create this portfolio?',
          PORTFOLIO_NAME: 'Portfolio Name',
          LAST_PUBLIC_DATE: 'Last updated date: %{publicDate}',
          SELECTED_PEERS: 'Selected peers:',
          VALIDATE_DUPLICATE_PORTFOLIO_NAME:
            'Name already exists. Please try again!',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companyAnalysis: {
        ...store.getState().i18n.translations.vi.companyAnalysis,
        peerAnalysis: {
          PEER_ANALYSIS: 'Phân tích ngang hàng',
          CONTACT_US: 'Liên hệ chúng tôi',
          CANCEL: 'Hủy',
          CONFIRMATION: 'Xác nhận',
          CLOSE: 'Đóng',
          APPLY: 'Áp dụng',
          DESCRIPTION_CONTENT_1:
            'Tính năng Phân tích ngang hàng cho phép người dùng so sánh hiệu quả hoạt động của công ty này với các đối thủ cạnh tranh, giúp bạn xác định các xu hướng và sự bất thường trong hành vi và kết quả. Từ đó củng cố đánh giá của bạn và giúp bạn xác định các cơ hội.',
          DESCRIPTION_CONTENT_2:
            'Một nhóm các công ty đối thủ có thể được tạo hoặc xuất tự động từ các doanh nghiệp có chung các đặc điểm nhất định. Cụ thể, người dùng Premium của FiinGate có thể tạo danh sách này bằng cách chọn các công ty trong các danh mục sẵn có của họ hoặc tìm kiếm trong cơ sở dữ liệu FiinGate. Bạn cũng sẽ nhận được các danh sách đề xuất từ FiinGate của các công ty có điểm tương đồng về:',
          INDUSTRY: 'Lĩnh vực hoạt động',
          REVENUE: 'Doanh thu',
          TOTAL_ASSETS: 'Tổng tài sản',
          YEAR_OF_OPERATION: 'Số năm hoạt động',
          UPGRADE_NOW: 'Nâng cấp ngay',
          RECOMMENDATION_LIST: 'Danh sách gợi ý',
          SAVE_LIST: 'Lưu danh sách',
          SEARCH_PLACEHOLDER: 'Nhập Tên, Mã Số Thuế hoặc Mã Chứng Khoán',
          OWNERSHIP_AND_GROUP: 'Quan Hệ & Sở Hữu',
          STRUCTURE_TYPE: 'Cấu Trúc Sở Hữu',
          COMPANY_NAME: 'Tên Công Ty',
          NUMBER_OF_BRANCHES: 'Số Lượng Chi Nhánh',
          NUMBER_OF_SUBSIDIARIES: 'Số Lượng Công Ty Con',
          NUMBER_OF_ASSOCIATED_COMPANIES: 'Số Lượng Công Ty Liên Kết',
          INDIVIDUAL: 'Cá Nhân',
          STATE_OWNED_ENTERPRISES: 'Doanh Nghiệp Nhà Nước',
          NON_STATE_ENTERPRISES: 'Doanh Nghiệp Ngoài Nhà Nước',
          MULTINATIONAL_COMPANIES: 'Doanh Nghiệp Đa Quốc Gia',
          OTHER: 'Khác',
          FINANCIAL_STATEMENT: 'Báo Cáo Tài Chính',
          FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_1:
            'Các công ty có thể sử dụng các thông tư khác nhau để trình bày báo cáo tài chính của họ. Mỗi loại thông tư sẽ có các tài khoản giống và khác nhau.',
          FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_2:
            'Các tài khoản trong danh sách này đến từ báo cáo tài chính của công ty chính (công ty đầu tiên trong danh sách), không phải công ty đối thủ. Khi một công ty đối thủ không có tài khoản đó trong báo cáo tài chính của họ, các giá trị sẽ để trống.',
          FINANCIAL_ANALYSIS: 'Phân Tích Tài Chính',
          FINANCIAL_ANALYSIS_TOOLTIP_DISCLAIMER:
            'Chỉ tiêu tài chính được thể hiện dựa trên loại hình của công ty gốc (công ty đầu tiên trong loại danh sách)',
          BALANCE_SHEET: 'Bảng Cân Đối Kế Toán',
          INCOME_STATEMENT: 'Báo Cáo Kết Quả Hoạt Động Kinh Doanh',
          CASH_FLOW_STATEMENT: 'Báo Cáo Lưu Chuyển Tiền Tệ',
          PORTFOLIO: 'Danh mục',
          CHOOSE_PORTFOLIO: 'Danh mục:',
          YEARS_OF_OPERATION: 'Số năm hoạt động',
          CREDIT_RISK_SCORE: 'Điểm rủi ro doanh nghiệp',
          PERFORMANCE_SCORE: 'Điểm Triển Vọng Tăng trưởng',
          SELECTED_COMPANY: 'Công ty được chọn (%{numberSelect})',
          ADD_TO_PEER_LIST: 'Thêm vào Phân tích',
          INDUSTRY_TABLE: 'Ngành',
          SCORE: 'Điểm Số',
          OVER_SELECTION_POPUP_TEXT: 'Bạn chỉ có thể chọn tối đa 30 công ty',
          OVER_SELECTION_CHART_POPUP_TEXT:
            'Bạn chỉ có thể chọn tối đa 4 công ty',
          NO_SELECTION_POPUP_TEXT: 'Không có công ty để lưu',
          SAVE_LIST_TITLE: 'Thêm vào danh mục',
          SEARCH_PORTFOLIO_PLACEHOLDER: 'Tìm kiếm danh mục',
          CREATE_NEW_PORTFOLIO: 'Tạo danh mục mới',
          PORTFOLIO_NAME: 'Tên Danh Mục',
          ENTER_NAME_PORTFOLIO: 'Nhập tên danh mục',
          CREATE_PORTFOLIO: 'Tạo danh mục',
          TEXT_CREATE_PORTFOLIO: 'Bạn có muốn tạo danh mục mới?',
          CANCEL_SAVE_LIST_POPUP_TEXT:
            'Công ty đã chọn sẽ không được đưa vào phân tích ngang hàng và danh sách này sẽ bị xóa. Bạn có muốn tiếp tục?',
          LAST_PUBLIC_DATE: 'Ngày cập nhật gần nhất: %{publicDate}',
          SELECTED_PEERS: 'Công ty được chọn để phân tích:',
          VALIDATE_DUPLICATE_PORTFOLIO_NAME:
            'Tên đã tồn tại. Vui lòng thử lại!',
        },
      },
    },
  }),
)
